import { Autocomplete, Icon, InputBase, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { User } from "../../entities/user";
import { useKronosUsers } from "../../../redux/kronos/kronosHooks";

/**
 * @param {userAutocompleteProps} userAutocompleteProps PriorityLevel object from API
 * @returns {ReactElement} User Autocomplete
 */
export function UserAutocomplete({
  userID,
  onChange,
  variant,
  size,
  helperText,
  disabled,
  autoFocus,
}: userAutocompleteProps) {
  const [inputValue, setInputValue] = useState("");
  const { users } = useKronosUsers();
  const user = users.find((u) => u.id === userID);

  useEffect(() => {
    if (user) {
      setInputValue(user.fullName());
    }
  }, [user]);

  return (
    <Autocomplete
      value={user ?? null}
      onChange={(_e, newValue) => {
        onChange(newValue);
      }}
      disabled={disabled}
      inputValue={inputValue}
      onInputChange={(_e, newInputValue) => {
        setInputValue(newInputValue);
      }}
      size={size}
      getOptionLabel={(option) => `${option.fullName()})`}
      options={users}
      clearIcon={<Icon sx={{ fontSize: 15 }} className="fa-solid fa-xmark" />}
      renderInput={(params) =>
        variant === "inputBase" ? (
          <div ref={params.InputProps.ref}>
            <InputBase
              inputProps={{ ...params.inputProps }}
              fullWidth
              sx={{ fontSize: 14 }}
              placeholder="Select a user..."
              autoFocus={autoFocus}
            />
          </div>
        ) : (
          <TextField
            variant={variant}
            {...params}
            fullWidth
            sx={{ fontSize: 14 }}
            placeholder="Select a user..."
            autoFocus={autoFocus}
            label="User"
            helperText={helperText}
          />
        )
      }
    />
  );
}

type userAutocompleteProps = {
  userID?: number;
  onChange: (user: User | null) => void;
  variant?: "standard" | "filled" | "outlined" | "inputBase" | undefined;
  size?: "small" | "medium" | undefined;
  helperText?: string;
  disabled?: boolean;
  autoFocus?: boolean;
};
